import { useIntl } from 'react-intl';
import { Tag, Tags } from '@/types';
import { EventTag } from './components/EventTag/EventTag';
import styles from './EventTags.module.scss';

export interface EventTagsProps {
  tags?: Tags;
}

export const EventTags = ({ tags }: EventTagsProps) => {
  const { formatMessage } = useIntl();

  if (!tags || tags.length === 0) {
    return null;
  }

  const validTags = tags.filter((tag: Tag) => !!tag?.link);

  if (validTags.length === 0) {
    return null;
  }

  return (
    <div className={styles.wrapper} data-testid="event-tags">
      <div className={styles.title}>{formatMessage({ id: 'Related' })}</div>
      <ul className={styles.tagsContainer}>
        {validTags.map((tag: Tag, index) => (
          <EventTag key={index} tag={tag} />
        ))}
      </ul>
    </div>
  );
};
